import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/guessbtc/Price_Box.png")